import { startsWithNumber } from "../app/utils";
import { prettyDate } from "../app/datetimeUtils";

interface Props {
	date: Date | string;
	action: string;
	preposition: string;
}

export default function DescriptiveDate({ date, action, preposition }: Props) {
	if (typeof date === "string") {
		date = new Date(date);
	}
	const pretty = prettyDate(date);

	const dateStr = startsWithNumber(pretty)
		? `${action} ${preposition} ${pretty.toLowerCase()}`
		: `${action} ${pretty.toLowerCase()}`;

	return <>{dateStr}</>;
}
